import { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { connect } from 'react-redux';
import { handleLocaleUrl } from 'dibs-intl/exports/handleLocaleUrl';

// components
import { FormattedMessage } from 'dibs-react-intl';
import { Button } from 'dibs-elements/exports/Button';

// mutations
import { SharedModifyPortfolioItems } from '../../mutations/FindingSharedModifyPortfolioItems';

// helpers
import get from 'lodash.get';
import { trackPurchaseClick } from '../tracking/actionButtonsTracking';
import { setCartItems } from '../../actions/sharedMobileActions';

// styles
import styles from './PdpSharedButtons.scss';

export class PdpSharedPurchaseButtonComponent extends Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    onClick(event) {
        const { item } = this.props;
        const hasPrivateListing = get(item, 'hasPrivateListing');
        trackPurchaseClick(item, event);

        if (!hasPrivateListing) {
            this.addToCart();
        }

        this.redirectToCheckout();
    }

    addToCart() {
        const { dispatch, userId, itemId } = this.props;
        if (!userId) {
            // If no user, store item - it can be ADDed to cart when user logs in later
            dispatch(setCartItems(itemId));
        } else {
            // ADD item to user's cart
            this.addToCartMutation();
        }
    }

    addToCartMutation() {
        const { relay, userId, itemId } = this.props;
        SharedModifyPortfolioItems.commit(relay.environment, {
            action: 'ADD',
            itemId,
            portfolioType: 'CART',
            userId,
            onCompleted: () => {
                this.redirectToCheckout();
            },
            onError: () => {
                this.redirectToCheckout();
            },
        });
    }

    getCheckoutUrl() {
        const { quantitySelected, itemId, skuId } = this.props;
        const href = `/checkout/id-${itemId}/`;
        const params = [];

        if (quantitySelected) {
            params.push(`quantity=${quantitySelected}`);
        }
        if (skuId) {
            params.push(`skuId=${skuId}`);
        }
        return `${href}${params.length ? '?' : ''}${params.join('&')}`;
    }

    redirectToCheckout() {
        const checkoutUrl = this.getCheckoutUrl();
        window.location.assign(handleLocaleUrl(checkoutUrl));
    }

    render() {
        const { isPrimary, item, disabled, label } = this.props;
        const isPrivateVisibilityType = get(item, 'isPrivateVisibilityType');
        const additionalProps = {};
        if (isPrivateVisibilityType) {
            additionalProps.type = 'primaryAlt';
        } else if (!isPrimary) {
            additionalProps.type = 'secondary';
        }

        return (
            <Button
                className={`${styles.button} ${styles.fullWidth}`}
                dataTn="item-actions-purchase-item"
                onClick={this.onClick}
                size={this.props.size}
                disabled={disabled}
                {...additionalProps}
            >
                {label ? (
                    <>{label}</>
                ) : (
                    <FormattedMessage
                        id="PdpSharedPurchaseButton.purchaseCta"
                        defaultMessage="Purchase"
                    />
                )}
            </Button>
        );
    }
}

PdpSharedPurchaseButtonComponent.defaultProps = {
    size: 'large',
    isPrimary: true,
    disabled: false,
};

PdpSharedPurchaseButtonComponent.propTypes = {
    item: PropTypes.object.isRequired,
    quantitySelected: PropTypes.string,
    relay: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    itemId: PropTypes.string,
    userId: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    isPrimary: PropTypes.bool,
    skuId: PropTypes.string,
    disabled: PropTypes.bool,
    label: PropTypes.element,
};

PdpSharedPurchaseButtonComponent = connect()(PdpSharedPurchaseButtonComponent);

export const PdpSharedPurchaseButton = createFragmentContainer(PdpSharedPurchaseButtonComponent, {
    item: graphql`
        fragment PdpSharedPurchaseButton_item on Item {
            isPrivateVisibilityType
            hasPrivateListing
            ...actionButtonsTracking_item @relay(mask: false)
        }
    `,
});
